import { Injectable } from '@angular/core';
import { PageDto } from 'app/@types/dto/page-dto.model';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ActivePageService {
    private activePage$: BehaviorSubject<PageDto | null> = new BehaviorSubject<PageDto | null>(null);

    public getActivePage() {
        return this.activePage$.asObservable().pipe(filter((activePage) => !!activePage));
    }

    public setActivePage(newPage: PageDto) {
        this.activePage$.next(newPage);
    }
}
